<template>
    <div class="filter">
        <a
            v-for="category in categories"
            :key="category.id"
            :class="{ active: category === selectedCategory}"
            class="filter__element"
            @click="toggleChip(category)">
            {{ category.name }}
        </a>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component
    export default class FilterChips extends Vue {
        name = 'filter-chips';
        selectedCategory = null;

        @Prop() categories;

        toggleChip(category) {
            this.selectedCategory = category === this.selectedCategory ? null : category;
            this.$emit('selected', this.selectedCategory);
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/general/FilterChips.vue